/* global localStorage:false, toastr:false */
(function() {
  'use strict';

  angular
    .module('pub.logo', [
    ])
    .controller('LogoCtrl', LogoCtrl);

  /** @ngInject */
  function LogoCtrl($scope, $state, PublisherAdminService, UploadService) {
    var vm = this;
    vm.model = {};
    vm.pathImgH = '';
    vm.pathImgH2 = '';
    vm.loadH = false;
    vm.loadH2 = false;

    var watch = $scope.$watch('vm.fileImgH', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadH = false;
        return;
      }

      if (newVal === null){
        vm.loadH = false;
        return;
      }

      vm.loadH = true;
      UploadService.save('publishers', newVal, 'img-logo-d', vm.model.id).then(function(fileName){
        vm.loadH = false;
        vm.model['img-logo-d'] = fileName;
        vm.pathImgH = fileName;
      });

    });

    var watch1 = $scope.$watch('vm.fileImgH2', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadH2 = false;
        return;
      }

      if (newVal === null){
        vm.loadH2 = false;
        return;
      }

      vm.loadH2 = true;
      UploadService.save('publishers', newVal, 'img-logo-l', vm.model.id).then(function(fileName){
        vm.loadH2 = false;
        vm.model['img-logo-l'] = fileName;
        vm.pathImgH2 = fileName;
      });

    });

    $scope.$on("$destroy", function(){
      watch();
      watch1();
    });

    PublisherAdminService.getPublisher().then(function(result){
      var data = localStorage.getItem('user');
      var pid = JSON.parse(data).user.producer['id-pu'];
      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i].id === pid) {
          vm.model.id = result.results[i].id;
          vm.model['img-logo-l'] = result.results[i]['img-logo-l'];
          vm.model['img-logo-d'] = result.results[i]['img-logo-d'];
          vm.model['color-bg'] = result.results[i]['color-bg'];
          vm.model['color-txt'] = result.results[i]['color-txt'];
          vm.pathImgH = vm.model['img-logo-d'];
          vm.pathImgH2 = vm.model['img-logo-l'];
          vm.model.t = result.results[i].t;
          vm.model.txt = result.results[i].txt;
          return;
        }
      }
    });

    vm.save = function(){
      PublisherAdminService.updatePublisher(vm.model.id, vm.model).then(function(){
        toastr.success('Save with success!');
      });
    };

  }

})();
